const login = {
  // Brand
  brandTitle: 'Xceptional',
  brandSubtitle: 'Learning',
  brandTagline: 'Futuristic · Clinical-Grade · Caring',
  heroTitle: "Empowering every<br />learner's journey",
  heroDescription: 'A unified platform connecting therapists, educators, coordinators, and families — built around the child, not the paperwork.',
  // Feature pills
  feature1Title: 'Student Caseload Management',
  feature1Sub: 'Holistic profiles & records',
  feature2Title: 'Therapy Session Tracking',
  feature2Sub: 'Notes, assessments & progress',
  feature3Title: 'Smart Scheduling',
  feature3Sub: 'Automated conflict detection',
  feature4Title: 'Progress Analytics',
  feature4Sub: 'Developmental domain insights',
  // Trust badges
  trustAccessible: 'WCAG-AA Accessible',
  trustEncrypted: 'End-to-End Encrypted',
  trustNDIS: 'NDIS Aligned',
  // Login form
  welcomeBack: 'Welcome back',
  signInSubtitle: 'Sign in to your Xceptional Learning account',
  signInAs: 'Sign in as',
  signIn: 'Sign In',
  signingIn: 'Signing in…',
  enterPassword: 'Enter your password',
  forgotPassword: 'Forgot password?',
  // Demo section
  demoCredentials: 'Demo credentials',
  tryDemoTitle: 'Try the demo',
  tryDemoDescription: 'Use any email + password (min 6 chars) with a selected role to explore the platform.',
  // Forgot password flow
  resetPasswordTitle: 'Reset your password',
  resetPasswordDescription: "Enter your account email and we'll send you a secure reset link.",
  sendResetLink: 'Send Reset Link',
  backToSignIn: 'Back to sign in',
  emailSentTitle: 'Email sent!',
  emailSentDescription: 'Check your inbox for the reset link. Redirecting…',
  // Validation
  emailRequired: 'Email address is required',
  emailInvalid: 'Please enter a valid email address',
  passwordRequired: 'Password is required',
  passwordMinLength: 'Password must be at least 6 characters',
  // Role labels
  roleAdmin: 'Admin',
  roleCoordinator: 'Coordinator',
  roleTherapist: 'Therapist',
  roleTeacher: 'Teacher',
  // Footer
  privacyPolicy: 'Privacy Policy',
  termsOfService: 'Terms of Service',
};

export default login;